// extracted by mini-css-extract-plugin
export default {"buttons":"Buttons_buttons__TFCRJ","btn":"Buttons_btn__txthL"};